import { PERSPECTIVE_TYPE } from '../../types/perspective';
import type { Perspective } from '../../types/perspective';
import { getDatabase, getDbmsId } from '../connections/connectionsDuck';
import { getAllPerspectives } from '../perspectives/perspectives';
import { getPerspective } from '../perspectives/perspectives.selector';
import { getStartWithProvidedGraph } from '../scene/scene.selectors';
import type { RootState } from '../types';

export const getNextActivePerspectiveId = (state: RootState): string => {
  const database = getDatabase(state);
  const dbmsId = getDbmsId(state);
  const providedGraph = getStartWithProvidedGraph(state);
  const allPerspectives: Perspective[] = getAllPerspectives(state);
  const perspective: Perspective | undefined = getPerspective(state);
  const defaultPerspective = allPerspectives.find(
    (p) => p.dbmsId === dbmsId && p.dbId === database?.id && p.type === PERSPECTIVE_TYPE.DEFAULT,
  );
  if (providedGraph && defaultPerspective && defaultPerspective.id !== perspective?.id) {
    return defaultPerspective.id;
  }
  return perspective?.id ?? '';
};
